import { Button, FormControl, Grid, TextareaAutosize, TextField, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

import './contacts.scss';

function Contacts() {
  const { translateMessage } = useMyIntl();

  return (
    <Grid container id={styles.ids.contacts} spacing={2}>
      <Grid size={12}>
        <Typography variant="h2" className="title" gutterBottom>
          {translateMessage('contacts.title')}
        </Typography>
      </Grid>
      <Grid size={4} className="item">
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'relative', paddingBottom: '87%', height: 0, overflow: 'hidden' }}>
            <iframe
              allowFullScreen
              src="https://maps.google.com/maps?q=varna+ice+rink&z=15&output=embed"
              title="Ice rink Varna"
              loading="lazy"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
              }}
            ></iframe>
          </div>
        </div>
      </Grid>
      <Grid size={4} className="item contactText">
        <Typography component="div" paddingBottom={'1.5rem'}>
          <Typography display={'flex'} justifyContent={'center'} gutterBottom variant="h5">
            {translateMessage('contacts.iceRink')}
          </Typography>
          <Typography display={'flex'} justifyContent={'center'}>
            {translateMessage('contacts.address')}
          </Typography>
        </Typography>
        <Typography component="div" paddingBottom={'1.5rem'}>
          <Typography display={'flex'} justifyContent={'center'} gutterBottom variant="h6">
            {translateMessage('contacts.mobilesTitle')}
          </Typography>
          <Typography display={'flex'} justifyContent={'center'}>
            {translateMessage('contacts.mobile.dp')}
          </Typography>
          <Typography display={'flex'} justifyContent={'center'}>
            {translateMessage('contacts.mobile.vm')}
          </Typography>
        </Typography>
        <Typography component="div">
          <Typography display={'flex'} justifyContent={'center'} gutterBottom variant="h6">
            {translateMessage('contacts.emailTitle')}
          </Typography>
          <Typography display={'flex'} justifyContent={'center'}>
            <a href={`mailto:${translateMessage('contacts.email')}`} color={styles.link.color.primary}>
              {translateMessage('contacts.email')}
            </a>
          </Typography>
        </Typography>
      </Grid>
      <Grid size={4} className="item">
        <FormControl sx={{ display: 'flex' }}>
          <TextField
            required
            className="input"
            label={translateMessage('contacts.form.name')}
            sx={{ backgroundColor: 'white', marginBottom: '1.2rem', width: '100%' }}
          />
          <TextField
            required
            className="input"
            label={translateMessage('contacts.form.mobile')}
            sx={{ backgroundColor: 'white', marginBottom: '1.2rem', width: '100%' }}
          />
          <TextField
            required
            className="input"
            label={translateMessage('contacts.form.email')}
            sx={{ backgroundColor: 'white', marginBottom: '1.2rem', width: '100%' }}
          />
          <TextareaAutosize
            required
            minRows={9}
            placeholder={translateMessage('contacts.form.request')}
            style={{ backgroundColor: 'white', marginBottom: '1.2rem', resize: 'vertical', width: '99%' }}
          />
          <Button
            type="submit"
            variant="contained"
            endIcon={<SendIcon />}
            sx={{ backgroundColor: styles.color.primary, width: '100%' }}
          >
            {translateMessage('contacts.form.submitButton')}
          </Button>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default Contacts;
